import React, { useContext, useEffect, useState } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { I18nContext } from 'translations';
import StopsList from './StopsList';
import PackagesList from './PackagesList';

export default function RouteTabs({ route, onFocusStop, selectedStopIds }) {
  const { translate } = useContext(I18nContext);
  const [tab, setTab] = useState('stops');

  // A selection made on the map is shown on the stop cards, so bring that tab back.
  useEffect(() => {
    if (selectedStopIds && selectedStopIds.length > 0) setTab('stops');
  }, [selectedStopIds]);

  const focusStop = (stopId) => {
    setTab('stops');
    onFocusStop && onFocusStop(stopId);
  };

  const tabStyle = { textTransform: 'uppercase', fontWeight: 700, fontSize: 13, letterSpacing: 0.4, minWidth: 100 };
  // Only the company that owns the booking sees packages across every company on a
  // multi-company route (see Pibox::DeliveryRoutes::WebVisibility#owner? in picap_api) — a
  // :company-level viewer only ever sees their own packages, so the label would be redundant.
  const showCompany = route.visibility === 'owner';

  return (
    <div data-testid="route-tabs" style={{ marginTop: 20 }}>
      <Tabs
        value={tab}
        onChange={(e, value) => setTab(value)}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label={translate('app.deliveryRoute.tabs.stops')} value="stops" data-testid="tab-stops" style={tabStyle} />
        <Tab label={translate('app.deliveryRoute.tabs.packages')} value="packages" data-testid="tab-packages" style={tabStyle} />
      </Tabs>

      <div style={{ marginTop: 12 }}>
        {tab === 'stops' && (
          <StopsList
            stops={route.stops}
            onFocusStop={onFocusStop}
            showCompany={showCompany}
            selectedStopIds={selectedStopIds}
          />
        )}
        {tab === 'packages' && <PackagesList packages={route.packages} onFocusStop={focusStop} showCompany={showCompany} />}
      </div>
    </div>
  );
}
